<template>
  <b-modal
      title="تبدیل به HLS"
      hide-footer
      id="modal-hls"
      header-bg-variant="light"
  >
    <div v-if="file">
      <p>تبدیل ویدیو <strong>{{ file.title || file.originalName }}</strong> به HLS با کیفیت‌های زیر:</p>
      <b-form-group>
        <b-form-checkbox-group v-model="selectedQualities" :options="qualityOptions"/>
      </b-form-group>
      <div class="text-muted small">
        <i class="fas fa-info-circle"></i> تبدیل در پس‌زمینه انجام می‌شود و ممکن است چند دقیقه طول بکشد.
      </div>
      <div class="d-flex justify-content-end mt-3">
        <b-button variant="success" :disabled="!selectedQualities.length" @click="convert">
          <i class="fas fa-film"></i> شروع تبدیل
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {BButton, BFormCheckboxGroup, BFormGroup, BModal} from 'bootstrap-vue'

export default {
  name: 'HlsConversionModal',
  components: {BModal, BFormGroup, BFormCheckboxGroup, BButton},
  props: {
    file: {type: Object, default: null}
  },
  data() {
    return {
      selectedQualities: ['240p', '480p', '720p'],
      qualityOptions: [
        {text: '240p (low)', value: '240p'},
        {text: '480p (SD)', value: '480p'},
        {text: '720p (HD)', value: '720p'},
        {text: '1080p (Full HD)', value: '1080p'}
      ]
    }
  },
  methods: {
    convert() {
      this.$emit('convert', this.selectedQualities)
      this.localVisible = false
    }
  }
}
</script>
